import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-brand">
          © {year} Monitorizare Flotă — o marcă a{' '}
          <a href="https://www.softconsult.ro/" target="_blank" rel="noopener noreferrer">
            SoftConsult
          </a>
        </div>
        <div className="app-footer-links">
          <a href="https://auto.softconsult.ro/confidentialitate" target="_blank" rel="noopener noreferrer">
            Politica de confidențialitate
          </a>
          <span className="app-footer-sep">·</span>
          <a href="https://auto.softconsult.ro/termeni" target="_blank" rel="noopener noreferrer">
            Termeni și condiții
          </a>
          <span className="app-footer-sep">·</span>
          <a href="https://auto.softconsult.ro/help" target="_blank" rel="noopener noreferrer">
            Ajutor
          </a>
        </div>
      </div>
    </footer>
  );
}
